<template>
	<v-card :elevation="elevation" :height="!height ? '100%' : ''" class="d-flex flex-column">
		<v-app-bar :class="showAppBar ? 'color-white' : ''" tag="div" dense flat :color="showAppBar ? 'primary' : 'white'" class="shrink">
			<v-app-bar-title> {{ title }} </v-app-bar-title>
			<v-spacer />
			<slot name="header-btn" />
		</v-app-bar>
		<v-sheet elevation="0" :height="height" class="overflow-y-auto shrink">
			<v-data-table
				locale="ja-JP"
				:headers="headers"
				:items="items"
				dense
				hide-default-footer
				disable-filtering
				disable-pagination
				disable-sort
				:mobile-breakpoint="240"
				:no-data-text="noDataText"
			>
				<template v-slot:item="{ item }">
					<slot name="record" :item="item" />
				</template>
			</v-data-table>
		</v-sheet>
	</v-card>
</template>

<script>
export default {
	props: {
		title: { type: String, required: false, default: null },
		height: { type: Number, required: false, default: 200 },
		items: { type: Array, required: true },
		headers: { type: Array, required: true },
		showAppBar: {
			type: Boolean,
			default: true,
			required: false,
		},
		elevation: {
			type: Number,
			default: 5,
			required: false,
		},
		noDataText: {
			type: String,
			default: "データがありません。",
			required: false,
		},
	},
	data() {
		return {}
	},
	computed: {},
}
</script>
